import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Form, FormGroup, Label } from 'reactstrap';
import { HoursField, TranslatableField } from '../../../components';
import { Field, reduxForm } from 'redux-form'

import moment from 'moment';
import 'moment/locale/fr';
import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css';

moment.locale('fr');
momentLocalizer();

let PeriodForm = (props) => {
    const { handleSubmit, pristine, submitting, isCreation } = props;

    const { t }                 = useTranslation();
    const { isLoading, period } = useSelector(state => state.periods);

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle><i className="fa fa-info-circle"></i>&nbsp;{t("periods.informations")}</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label for="name" sm={12}>{t("periods.name")}</Label>
                                            <Col sm={12}>
                                            <TranslatableField name="name" placeholder={t("periods.name_placeholder")} component="input" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <FormGroup row>
                                                    <Label for="start_at" sm={12}>{t('periods.active_from')}</Label>
                                                    <Col>
                                                        <Field
                                                            component="input"
                                                            type="time"
                                                            name="start_at"
                                                            step={60}
                                                            className="form-control"
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup row>
                                                    <Label for="stop_at" sm={12}>{t("periods.active_until")}</Label>
                                                    <Col>
                                                        <Field
                                                            component="input"
                                                            type="time"
                                                            name="stop_at"
                                                            step={60}
                                                            className="form-control"
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <br/>
                <Row>
                    <Col className="text-center">
                        <br/>
                        <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                            {isLoading ?
                                <span>
                                    &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                </span>
                                :
                                <span>
                                    <i className="fa fa-save"></i>&nbsp;
                                    {t("common.save")}
                                </span>
                            }
                        </Button>
                    </Col>
                </Row>
        </Form>
    );

}

PeriodForm = reduxForm({
  form: 'periodForm',
  enableReinitialize: true
})(PeriodForm);

PeriodForm = connect(
  state => ({
    initialValues: state.periods.period,
    Periods: state.periods,
}), {}
)(PeriodForm)

export default PeriodForm;
